import React, { useState } from 'react';
import Navbar from '../components/Feed/FeedNavbar';
import LeftSidebar from '../components/Feed/LeftSidebar';
import RightSidebar from '../components/Feed/RightSidebar';
import MainFeed from '../components/Feed/MainFeed';
import PostTypeFilters from '../components/Feed/PostTypeFilters';
import BottomNavbar from '../utils/unifiedBottom';
import { useMediaQuery } from '../hooks/useMediaQuery';

const FeedPage = () => {
  const [isRightSidebarOpen, setIsRightSidebarOpen] = useState(false);
  
  // Check if screen is at least 1280px (Tailwind's 'xl' breakpoint)
  const isDesktop = useMediaQuery('(min-width: 1280px)');

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar isRightSidebarOpen={isRightSidebarOpen} setIsRightSidebarOpen={setIsRightSidebarOpen} />

      <div className="pt-2 lg:pt-20 flex justify-center max-w-7xl mx-auto gap-4 lg:gap-4 xl:gap-6 px-4 lg:px-6">
        <LeftSidebar isRightSidebarOpen={isRightSidebarOpen} />

        <div className="flex-1 min-w-0 w-full lg:max-w-[650px] xl:max-w-none">
          <PostTypeFilters />
          <MainFeed />
        </div>

        {/* Only render the component if isDesktop is true. 
            This prevents the RightSidebar component from mounting, 
            which in turn prevents the API call.
        */}
        {isDesktop && (
          <div className="w-80 flex-shrink-0">
            <RightSidebar isVisible={isDesktop} />
          </div>
        )}
      </div>

      <div className="lg:hidden">
        <BottomNavbar />
      </div>
    </div>
  );
};

export default FeedPage;